import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const notes_data = [
  {
    id: 1,
    title: 'Уд',
    description:
      'Одна з найцінніших і найрідкісніших парфумерних нот, яку отримують із деревини агарового дерева. Темний, смолистий, гіпнотичний — він ніколи не звучить банально. Це вибір тих, хто звик грати за власними правилами. Аромат-синонім впливу та абсолютної впевненості. У парфумах уд робить звучання більш насиченим і багатогранним, створюючи довгий, виразний шлейф, відчуваючись як насичена деревина, теплі смоли, легкий дим.',
    image: '/images/26ua-prl-notes/oud.jpg'
  },
  {
    id: 2,
    title: 'Шкіра',
    description:
      'Благородна текстура, перекладена мовою парфумерії. Шкіряні акорди формують витончену ауру та підкреслюють статус, а в поєднанні з квітковими нотами набувають делікатної м’якості. У парфумах шкіра нагадує м’яку замшу, дорогі шкіряні аксесуари та благородні деревні нюанси, додаючи аромату глибини й характеру. Проте, її не створюють буквально зі шкіри. Парфумери відтворюють її звучання за допомогою поєднання натуральних і синтетичних компонентів.',
    image: '/images/26ua-prl-notes/leather.jpg'
  },
  {
    id: 3,
    title: 'Ветивер',
    description:
      'Землистий, злегка димний акорд із сухою деревною глибиною, який отримують із коренів однойменної тропічної рослини. Символізує зібраність та інтелект — для моментів абсолютного фокусу й ясності думок. У парфумах ветивер додає композиції структури, свіжості та глибини. Він врівноважує солодкі й насичені ноти, роблячи аромат більш елегантним, чистим і багатогранним.',
    image: '/images/26ua-prl-notes/vetiver.jpg'
  },
  {
    id: 4,
    title: 'Тубероза',
    description:
      'Кремово-квіткова хвиля з теплою, чуттєвою глибиною. Її аромат повільно розкривається на шкірі, огортаючи м’яким світлом, у якому поєднуються сила, привабливість і тиха магія присутності. На запах тубероза розкривається насиченими білими квітами з оксамитовими та злегка медовими відтінками. Вона походить із квітів однойменної рослини, що вирощується в країнах із теплим кліматом. Для створення парфумерних композицій використовують її екстракт.',
    image: '/images/26ua-prl-notes/tuberose.jpg',
    titleColor: '#595959'
  },
  {
    id: 5,
    title: 'Акватика',
    description:
      'Свіжість морського бризу та ранкової роси, які зазвичай передають чистоту звучання: прохолодні морські, озонові та свіжі повітряні відтінки. Ці акорди не отримують із природних джерел, а відтворюють за допомогою спеціальних ароматичних молекул, щоб вони нагадували прохолоду морських хвиль і свіже повітря після дощу. Такі ноти обирають візіонери — ті, хто завжди на крок попереду й цінує власний простір. Акватика надає композиції чистоти, легкості та відчуття свободи.',
    image: '/images/26ua-prl-notes/aquatic.jpg'
  },
  {
    id: 6,
    title: 'Тютюн',
    description:
      'Теплий і густий акорд із м’якою, іноді медовою пряною глибиною. Його аромат оксамитово огортає, звучачи впевнено й стримано, як тиха розмова про досвід і внутрішню рівновагу. Попри назву, тютюновий акорд у парфумах часто створюють не з тютюну напряму, а за допомогою поєднання натуральних і синтетичних компонентів. Ноти меду, бобів тонка, сухофруктів, спецій, деревини та ванілі допомагають відтворити характерний аромат тютюнового листя.',
    image: '/images/26ua-prl-notes/tobacco.jpg'
  }
];

const quiz_questions = [
  {
    id: 1,
    question: 'Як зазвичай ти ведеш справи?',
    options: [
      { id: 'A', text: 'Зважений розрахунок і стратегія', type: 'woody' },
      { id: 'B', text: 'Готовність до ризику', type: 'spicy' },
      { id: 'C', text: 'Увага до деталей', type: 'leather' },
      { id: 'D', text: 'Пошук інновацій', type: 'aquatic' }
    ]
  },
  {
    id: 2,
    question: 'Уяви свій ідеальний вечір. Де ти?',
    options: [
      { id: 'A', text: 'У кабінеті зі смачним напоєм', type: 'woody' },
      { id: 'B', text: 'У центрі подій мегаполіса', type: 'spicy' },
      { id: 'C', text: 'На ексклюзивному заході', type: 'leather' },
      { id: 'D', text: 'У подорожі туди, де ніколи не був', type: 'aquatic' }
    ]
  },
  {
    id: 3,
    question: 'Твій стиль у спілкуванні:',
    options: [
      { id: 'A', text: 'Мої слова рідкісні, але точні', type: 'woody' },
      { id: 'B', text: 'Легко переконую кого завгодно', type: 'spicy' },
      { id: 'C', text: 'Тонко відчуваю настрій інших', type: 'leather' },
      { id: 'D', text: 'Надихаю на нестандартні ідеї', type: 'aquatic' }
    ]
  },
  {
    id: 4,
    question: 'На що ти звертаєш увагу в першу чергу під час знайомства?',
    options: [
      { id: 'A', text: 'На манери', type: 'woody' },
      { id: 'B', text: 'На впевненість', type: 'spicy' },
      { id: 'C', text: 'На приховані емоції', type: 'leather' },
      { id: 'D', text: 'На відкритість і хід думок', type: 'aquatic' }
    ]
  },
  {
    id: 5,
    question: 'Що для тебе означає успіх?',
    options: [
      { id: 'A', text: 'Стабільність і блискуча репутація', type: 'woody' },
      { id: 'B', text: 'Підкорення нових вершин', type: 'spicy' },
      { id: 'C', text: 'Внутрішня незалежність', type: 'leather' },
      { id: 'D', text: 'Можливість змінювати правила', type: 'aquatic' }
    ]
  }
];

const quiz_results = {
  woody: {
    title: 'Деревна класика',
    description:
      'Твоя сила — у виваженості та непохитності. Твій парфумерний профіль — це глибокі деревні ноти (сандал, кедр, дубовий мох).'
  },
  spicy: {
    title: 'Пряний Схід',
    description:
      'Твоя енергія заповнює весь простір. Вибирай інтенсивні композиції з нотами перцю, амбри та мускусу, що залишають яскравий слід.'
  },
  leather: {
    title: 'Благородна шкіра',
    description:
      'Ти вмієш читати між рядків. Твій аромат — складні, аристократичні шкіряні та тютюнові акорди. Вони звучать дорого, закрито і виключно для обраних.'
  },
  aquatic: {
    title: 'Свіжа акватика',
    description:
      'Твоя особливість — це свобода мислення. Тож аромат має бути активним і свіжим. Шукай натхнення у прохолодних акватичних та озонових нотах.'
  }
};

const WelcomeScreen = ({ handleToProduct }) => {
  const { sendEvent } = useContext(DataLayerEventContext);
  const containerRef = useRef(null);
  const notesRef = useRef(null);
  const gifContainerRef = useRef(null);
  const scrollTimeoutRef = useRef(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [result, setResult] = useState(null);
  const [showStickyButton, setShowStickyButton] = useState(false);
  const [startedChallenge, setStartedChallenge] = useState(false);

  useEffect(() => {
    return () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);

  const handleScroll = (e) => {
    if (gifContainerRef.current) {
      const threshold = gifContainerRef.current.offsetHeight * 0.75;
      const isBottom =
        e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 50;

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }

      if (e.target.scrollTop > threshold) {
        setShowStickyButton(true);

        if (!isBottom) {
          scrollTimeoutRef.current = setTimeout(() => {
            setShowStickyButton(false);
          }, 3000);
        }
      } else {
        setShowStickyButton(false);
      }
    }
  };

  const handleAnswer = (option) => {
    if (!startedChallenge) sendEvent('challenge');
    const newAnswers = [...answers];
    newAnswers[currentStep] = option;
    setStartedChallenge(true);
    setAnswers(newAnswers);
  };

  const handleNext = () => {
    if (currentStep < quiz_questions.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      calculateResult();
    }
  };

  const calculateResult = () => {
    const counts = answers.reduce((acc, answer) => {
      acc[answer.type] = (acc[answer.type] || 0) + 1;
      return acc;
    }, {});

    let maxType = 'woody';
    let maxCount = 0;
    for (const type in counts) {
      if (counts[type] > maxCount) {
        maxCount = counts[type];
        maxType = type;
      }
    }

    sendEvent('challenge_success');
    setResult(quiz_results[maxType]);
  };

  const handleScrollToNotes = () => {
    if (containerRef.current && notesRef.current) {
      containerRef.current.scrollTo({
        top: notesRef.current.offsetTop - 10,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div
      className={styles.container}
      ref={containerRef}
      onScroll={handleScroll}
    >
      <div
        className={`${styles.stickyButton} ${showStickyButton ? styles.visible : ''}`}
        onClick={handleToProduct}
      >
        <p>До продукту</p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
        >
          <circle cx="15" cy="15" r="15" fill="url(#paint0_linear_1864_1348)" />
          <path
            d="M13 21L18.6464 15.3536C18.8417 15.1583 18.8417 14.8417 18.6464 14.6464L13 9"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1864_1348"
              x1="15"
              y1="0"
              x2="15"
              y2="30"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#B58560" />
              <stop offset="1" stopColor="#76685F" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className={styles.content}>
        <div className={styles.gifContainer} ref={gifContainerRef}>
          <img
            src={getImageFromS3('images/26ua-prl-n/regular-line-prl.gif')}
            alt="regular-line-prl"
            className={styles.gif}
          />
          <div className={styles.gifOverlay}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="109"
              height="83"
              viewBox="0 0 109 83"
              fill="none"
            >
              <path
                d="M107.614 0.5L54.2686 82.0859L0.924805 0.5H107.614Z"
                stroke="url(#paint0_linear_1528_1277)"
              />
              <path
                d="M0 0L54.2692 22.8373L108.538 0L54.7298 48.6213L0 0Z"
                fill="url(#paint1_linear_1528_1277)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_1528_1277"
                  x1="0"
                  y1="41.5"
                  x2="108.538"
                  y2="41.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C9AC71" />
                  <stop offset="0.5" stopColor="#FFF0D2" />
                  <stop offset="1" stopColor="#C9AC71" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_1528_1277"
                  x1="30.4497"
                  y1="19.645"
                  x2="71.213"
                  y2="42.7278"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#EFE1C2" />
                  <stop offset="0.590836" stopColor="#E2C995" />
                  <stop offset="1" stopColor="#8D836E" />
                </linearGradient>
              </defs>
            </svg>
            <p className={styles.gifTitle}>Власна унікальність</p>
            <p className={styles.gifDescription}>
              Незримий підпис,
              <br />
              що живе в найдрібніших деталях.
              <br />
              Вишуканість, що транслює
              <br />
              характер точніше за будь-
              <br />
              які слова.
            </p>
            <div
              className={styles.learnMoreButton}
              onClick={handleScrollToNotes}
            >
              <img
                src={getImageFromS3('images/26ua-prl-n/glass-button.png')}
                alt="glass-button"
                className={styles.buttonBg}
              />
              <p>Дізнатись більше</p>
            </div>
          </div>
        </div>
        <div className={styles.notesContainer} ref={notesRef}>
          <img
            src={getImageFromS3('images/26ua-prl-n/pre-title-line.png')}
            alt="pre-title-line"
            className={styles.line}
          />
          <p className={styles.notesTitle}>Мистецтво ароматів</p>
          <p className={styles.notesSubTitle}>
            Твій парфум говорить раніше за тебе.
            <br />
            Ніби унікальний почерк, він передає особистість та статус його
            власника.
          </p>
          <p className={styles.notesDescription}>
            Дізнайся більше про парфумерні ноти й обери ту, що звучить в унісон
            із тобою.
          </p>
          <div className={styles.notesSwiper}>
            <Swiper
              modules={[Pagination]}
              pagination={{ clickable: true }}
              spaceBetween={20}
              slidesPerView={'auto'}
              centeredSlides={true}
              className={styles.mySwiper}
            >
              {notes_data.map((note) => (
                <SwiperSlide key={note.id} className={styles.noteSlide}>
                  <div className={styles.noteCard}>
                    <img
                      src={note.image}
                      alt={note.title}
                      className={styles.noteImage}
                    />
                    <p
                      className={styles.noteName}
                      style={
                        note.titleColor ? { color: note.titleColor } : undefined
                      }
                    >
                      {note.id}. {note.title}
                    </p>
                    <div className={styles.noteFooter}>
                      <p className={styles.noteDescText}>{note.description}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className={styles.swiperSubtitleContainer}>
            <img
              src={getImageFromS3('images/26ua-prl-n/blue-shadow.png')}
              alt="blue-shadow"
              className={styles.shadow}
            />
            <p className={styles.swiperSubtitleContainerTitle}>
              Знайти свій парфум — це мистецтво.
            </p>
            <p className={styles.swiperSubtitleContainerDescription}>
              Іноді варто довіритися першому вдиху і просто дозволити аромату
              самому обрати тебе.
            </p>
          </div>
          <img
            src={getImageFromS3('images/26ua-prl-n/pre-title-line.png')}
            alt="pre-title-line"
            className={styles.line}
            style={{ marginTop: '47px' }}
          />
        </div>
        <div className={styles.quizContainer}>
          <img
            src={getImageFromS3('images/26ua-prl-n/quiz-blue-shadow.png')}
            alt="quiz-brown-shadow"
            className={styles.quizShadow}
          />
          <p className={styles.quizTitle}>Тест</p>
          <p className={styles.quizMainTitle}>Який твій ароматичний підпис?</p>
          <p className={styles.quizSubTitle}>
            За кожним парфумом стоїть свій характер.
          </p>
          <p className={styles.quizDescription}>
            Хтось випромінює спокійний авторитет, а хтось — невпинну динаміку.
            <br />
            <br />
            Дай відповідь на кілька запитань і дізнайся, який парфум створений
            саме для тебе.
          </p>
          <div className={styles.quiz}>
            {!result ? (
              <div className={styles.quizCard}>
                <div className={styles.quizQuestionContainer}>
                  <p className={styles.questionNumber}>
                    {quiz_questions[currentStep].id}.{' '}
                    {quiz_questions[currentStep].question}
                  </p>
                  <div className={styles.options}>
                    {quiz_questions[currentStep].options.map((option) => (
                      <button
                        key={option.id}
                        className={`${styles.option} ${answers[currentStep]?.id === option.id ? styles.active : ''}`}
                        onClick={() => handleAnswer(option)}
                      >
                        <span className={styles.optionRadio} />
                        <span className={styles.optionText}>{option.text}</span>
                      </button>
                    ))}
                  </div>
                </div>
                <div className={styles.quizFooter}>
                  <div className={styles.buttonContainer}>
                    <button
                      className={styles.nextButton}
                      disabled={!answers[currentStep]}
                      onClick={handleNext}
                    >
                      <svg
                        width="50"
                        height="50"
                        viewBox="0 0 50 50"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width="50"
                          height="50"
                          rx="25"
                          fill="#C8A389"
                          fillOpacity="0.1"
                        />
                        <rect
                          x="0.5"
                          y="0.5"
                          width="49"
                          height="49"
                          rx="24.5"
                          stroke="#C8A389"
                          strokeOpacity="0.8"
                        />
                        <path
                          d="M11 24C10.4477 24 10 24.4477 10 25C10 25.5523 10.4477 26 11 26V25V24ZM38.7071 25.7071C39.0976 25.3166 39.0976 24.6834 38.7071 24.2929L32.3431 17.9289C31.9526 17.5384 31.3195 17.5384 30.9289 17.9289C30.5384 18.3195 30.5384 18.9526 30.9289 19.3431L36.5858 25L30.9289 30.6569C30.5384 31.0474 30.5384 31.6805 30.9289 32.0711C31.3195 32.4616 31.9526 32.4616 32.3431 32.0711L38.7071 25.7071ZM11 25V26H38V25V24H11V25Z"
                          fill="#C8A389"
                        />
                      </svg>
                    </button>
                  </div>
                  <div className={styles.progressBar}>
                    {quiz_questions.map((_, index) => (
                      <div
                        key={index}
                        className={`${styles.progressSegment} ${index === currentStep ? styles.active : ''}`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              <div className={styles.resultCard}>
                <p className={styles.resultLabel}>Результат</p>
                <p className={styles.resultTitle}>{result.title}</p>
                <p className={styles.resultDescription}>{result.description}</p>
                <div className={styles.resultLine} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
